import { createAsyncThunk } from "@reduxjs/toolkit";
import { MixService } from "../../services/MixService";
import type { AxiosError, AxiosRequestConfig } from "axios";
import { MixInterface } from "../../entities/Mix";

export const fetchMixesByFuchsByCategoryId = createAsyncThunk<
  MixInterface[],
  AxiosRequestConfig,
  { rejectValue: AxiosError }
>(
  "mix/fetchByFuchsByCategoryId",
  async (config: AxiosRequestConfig, { rejectWithValue }) => {
    try {
      const { data } = await MixService.getMixesByFuchsByCategoryId(config);
      return data;
    } catch (e: any) {
      return rejectWithValue(e.message as AxiosError);
    }
  },
);
